import script from "./QuestionComponent.vue?vue&type=script&setup=true&lang=ts"
export * from "./QuestionComponent.vue?vue&type=script&setup=true&lang=ts"

import "./QuestionComponent.vue?vue&type=style&index=0&id=2806b658&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-2806b658"]])

export default __exports__